<template>
  <div class="ls-feedback">
    <button
      type="button"
      class="ls-feedback__interest"
      data-test="ls-detail-interest"
      :aria-pressed="interested ? 'true' : 'false'"
      @click="$emit('interest')"
    >
      <svg
        v-if="interested"
        viewBox="0 0 24 24"
        width="16"
        height="16"
        aria-hidden="true"
        focusable="false"
      ><path
        d="M5 12.5l4.5 4.5L19 7.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      /></svg>
      <span>{{ interested ? 'Interested' : 'I\'m interested' }}</span>
    </button>
    <ls-feedback-text
      :label="`Note to ${brandName}`"
      :value="comment"
      :limit="limit"
      :status="status"
      @input="text => $emit('comment', text)"
      @commit="$emit('commit')"
    />
  </div>
</template>

<script>
import LsFeedbackText from './LsFeedbackText.vue'

/**
 * Interest and a note on one style, in the detail view (KP-4572). The heart
 * keeps a style on the shortlist; "I'm interested" says the buyer wants to
 * talk about ordering it. Both may be on.
 */
export default {
  name: 'LsProductFeedback',
  components: { LsFeedbackText },
  props: {
    brandName: { type: String, required: true },
    interested: { type: Boolean, default: false },
    comment: { type: String, default: '' },
    status: { type: String, default: 'idle' },
    limit: { type: Number, default: 1000 },
  },
}
</script>

<style lang="scss" scoped>
@import './ls-base';

.ls-feedback {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__interest {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 48px;
    border: 1px solid var(--ls-ink);
    border-radius: var(--ls-radius);
    background: transparent;
    color: var(--ls-ink);
    font: 600 0.9375rem/1 var(--ls-body-font);
    cursor: pointer;
    touch-action: manipulation;
    transition: background-color 0.2s $ls-ease, color 0.2s $ls-ease;
    @include ls-focus;

    &[aria-pressed='true'] {
      background: var(--ls-ink);
      color: var(--ls-ground);
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .ls-feedback__interest {
    transition: none;
  }
}
</style>
